import React, { useState, useEffect } from 'react';
import { userService } from '../../services/userService';

interface UserDisplayProps {
  email: string;
  style?: React.CSSProperties;
}

const UserDisplay: React.FC<UserDisplayProps> = ({ email, style }) => {
  const [displayName, setDisplayName] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (!email) {
        setDisplayName('');
        setLoading(false);
        return;
      }

      try {
        const response = await userService.searchEmployees(email);
        if (response.employees && response.employees.length > 0) {
          const employee = response.employees[0];
          const fullNameTh = `${employee.name_prefix_th}${employee.first_name_th} ${employee.last_name_th}`.trim();
          const fullNameEn = `${employee.first_name_en} ${employee.last_name_en}`.trim();
          
          // Prefer Thai name, fallback to English name
          const name = fullNameTh || fullNameEn;
          
          setDisplayName(name || email);
        } else {
          // Fallback to email if no employee found
          setDisplayName(email);
        }
      } catch (error) {
        console.error('Error fetching user info:', error);
        // Fallback to email on error
        setDisplayName(email);
      } finally {
        setLoading(false);
      }
    };

    fetchUserInfo();
  }, [email]);

  if (loading) {
    return <span style={style}>กำลังโหลด...</span>;
  }

  // If displayName is same as email (fallback case), show just email
  if (displayName === email) {
    return <span style={style}>{email}</span>;
  }

  // Show name with email in smaller text
  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', ...style }}>
      <div style={{ fontWeight: 500 }}>
        {displayName}
      </div>
      <div style={{ fontSize: '12px', color: '#666' }}>
        {email}
      </div>
    </div>
  );
};

export default UserDisplay;
